module.exports = __webpack_public_path__ + "static/tabhopmobile-9108fc0cedfdd4099e20f6e91b376827.png";